import { StiSectionOne } from '@/components/sti/StiSectionOne'
import { StiSectionTwo } from '@/components/sti/StiSectionTwo'
import { StiSectionThree } from '@/components/sti/StiSectionThree'
import { StiSectionFour } from '@/components/sti/StiSectionFour'
import { StiSectionFive } from '@/components/sti/StiSectionFive'
import { ContactUs } from '@/components/ContactUs'

export const StiRouteComponent = () => {
	return (
		<>
			<StiSectionOne />
			<StiSectionTwo />
			<StiSectionThree />
			<StiSectionFour />
			<ContactUs
				subtitle={
					'If you have any questions or would like to schedule an appointment for STI and STD testing or counseling, please don`t hesitate to' +
					' reach out. Your sexual health is our priority. '
				}
				title={'Contact Us'}
				noLocations
				heading={''}
			/>
			<StiSectionFive />
		</>
	)
}
